import './assets/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'babel-polyfill';
import './polyfills/array.includes.polyfill';
import './main.scss';

import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import 'keen-ui/src/bootstrap';
import 'keen-ui/dist/keen-ui.css';

import App from './App.vue';
import Form from './views/form.vue';
import Result from './views/result.vue';

Vue.use(BootstrapVue);
Vue.use(VueRouter);

Vue.component("app", App);


let router = new VueRouter({
  routes: [
    { path: "/", component: Form },
    { path: "/result", component: Result },
  ]
});

new Vue({
  router,
  template: "<app />"
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js